module.exports = __webpack_public_path__ + "img/车牌识别.0cb73cd9.png";